module.exports = __webpack_public_path__ + "media/recipes/135-c74fb04a.png";